import { Constructor } from '@skylab-shared/types';
import { Validations } from '../../validation';
import { copyPropertiesFromParent, copyValidationsFromParent } from './copy-from-parent';
import { ModelBase } from './model-base';
import { ModelMetadataContainer } from './model-metadata-container';

declare type ModelConstructor<TModel extends ModelBase> = Constructor<TModel>;
declare type ModelDecorator<TModel extends ModelBase> = (target: ModelConstructor<TModel>) => void;

export function CopyMetadataFromParent<TModel extends ModelBase>(): ModelDecorator<TModel> {
    return target => {
        const modelMetadata: ModelMetadataContainer = Reflect.getMetadata('skl:model', target) || new ModelMetadataContainer();
        copyPropertiesFromParent(modelMetadata, <Constructor<ModelBase>> target);
        Reflect.defineMetadata('skl:model', modelMetadata, target);

        const validations: Validations = Reflect.getMetadata('skl:validations', target) || {};
        const mergedValidations = copyValidationsFromParent(validations, <Constructor<ModelBase>> target);
        Reflect.defineMetadata('skl:validations', mergedValidations, target);
    };
}
